/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InitiativeHealthRow } from './InitiativeHealthRow';
import {
    InitiativeHealthRowFromJSON,
    InitiativeHealthRowFromJSONTyped,
    InitiativeHealthRowToJSON,
    InitiativeHealthRowToJSONTyped,
} from './InitiativeHealthRow';
import type { ExceptionItem } from './ExceptionItem';
import {
    ExceptionItemFromJSON,
    ExceptionItemFromJSONTyped,
    ExceptionItemToJSON,
    ExceptionItemToJSONTyped,
} from './ExceptionItem';
import type { CadenceCalendarItem } from './CadenceCalendarItem';
import {
    CadenceCalendarItemFromJSON,
    CadenceCalendarItemFromJSONTyped,
    CadenceCalendarItemToJSON,
    CadenceCalendarItemToJSONTyped,
} from './CadenceCalendarItem';
import type { DashboardSummary } from './DashboardSummary';
import {
    DashboardSummaryFromJSON,
    DashboardSummaryFromJSONTyped,
    DashboardSummaryToJSON,
    DashboardSummaryToJSONTyped,
} from './DashboardSummary';

/**
 * 
 * @export
 * @interface ProgramManagerDashboardView
 */
export interface ProgramManagerDashboardView {
    /**
     * 
     * @type {Date}
     * @memberof ProgramManagerDashboardView
     */
    computedAt?: Date;
    /**
     * 
     * @type {Array<InitiativeHealthRow>}
     * @memberof ProgramManagerDashboardView
     */
    initiativeHealth?: Array<InitiativeHealthRow>;
    /**
     * 
     * @type {Array<ExceptionItem>}
     * @memberof ProgramManagerDashboardView
     */
    exceptions?: Array<ExceptionItem>;
    /**
     * 
     * @type {Array<CadenceCalendarItem>}
     * @memberof ProgramManagerDashboardView
     */
    upcomingCadence?: Array<CadenceCalendarItem>;
    /**
     * 
     * @type {DashboardSummary}
     * @memberof ProgramManagerDashboardView
     */
    summary?: DashboardSummary;
}

/**
 * Check if a given object implements the ProgramManagerDashboardView interface.
 */
export function instanceOfProgramManagerDashboardView(value: object): value is ProgramManagerDashboardView {
    return true;
}

export function ProgramManagerDashboardViewFromJSON(json: any): ProgramManagerDashboardView {
    return ProgramManagerDashboardViewFromJSONTyped(json, false);
}

export function ProgramManagerDashboardViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramManagerDashboardView {
    if (json == null) {
        return json;
    }
    return {
        
        'computedAt': json['computedAt'] == null ? undefined : (new Date(json['computedAt'])),
        'initiativeHealth': json['initiativeHealth'] == null ? undefined : ((json['initiativeHealth'] as Array<any>).map(InitiativeHealthRowFromJSON)),
        'exceptions': json['exceptions'] == null ? undefined : ((json['exceptions'] as Array<any>).map(ExceptionItemFromJSON)),
        'upcomingCadence': json['upcomingCadence'] == null ? undefined : ((json['upcomingCadence'] as Array<any>).map(CadenceCalendarItemFromJSON)),
        'summary': json['summary'] == null ? undefined : DashboardSummaryFromJSON(json['summary']),
    };
}

export function ProgramManagerDashboardViewToJSON(json: any): ProgramManagerDashboardView {
    return ProgramManagerDashboardViewToJSONTyped(json, false);
}

export function ProgramManagerDashboardViewToJSONTyped(value?: ProgramManagerDashboardView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'computedAt': value['computedAt'] == null ? undefined : ((value['computedAt']).toISOString()),
        'initiativeHealth': value['initiativeHealth'] == null ? undefined : ((value['initiativeHealth'] as Array<any>).map(InitiativeHealthRowToJSON)),
        'exceptions': value['exceptions'] == null ? undefined : ((value['exceptions'] as Array<any>).map(ExceptionItemToJSON)),
        'upcomingCadence': value['upcomingCadence'] == null ? undefined : ((value['upcomingCadence'] as Array<any>).map(CadenceCalendarItemToJSON)),
        'summary': DashboardSummaryToJSON(value['summary']),
    };
}

